import React from 'react'
import SnippetWithOverlay from '../SnippetWithOverlay'
import { AnnotationDataBoundingBox } from '../../types/models/annotation'
import PillsClassification from '../PillsClassification'
//

export interface SnippetItemProps {
  contentId: string
  bbox?: AnnotationDataBoundingBox
  isSelected: boolean
  height?: number
  tagNames?: string[] | undefined
  tagConfidence?: number[] | undefined
  projectAnnotationType: string
  rotateLongSideVertical?: boolean
}

const SnippetItem: React.FC<SnippetItemProps> = ({
  contentId,
  bbox,
  isSelected,
  height = 150,
  tagNames,
  tagConfidence,
  projectAnnotationType,
  rotateLongSideVertical = false,
}) => {
  return (
    <div className="bg-dark rounded p-2" style={{ borderColor: 'rgba(255,255,255,0.1)' }}>
      <div
        className="mb-2"
        style={{
          backgroundColor: '#1a1a1a',
          padding: '1rem',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          borderRadius: '4px',
          overflow: 'hidden',
          width: '100%',
          minHeight: `${height}px`,
        }}
      >
        {bbox && (
          <SnippetWithOverlay
            projectAnnotationType={projectAnnotationType}
            contentId={contentId}
            bbox={bbox}
            isSelected={isSelected}
            rotateLongSideVertical={rotateLongSideVertical}
          />
        )}
        <div className="mt-2">
          <PillsClassification tagNames={tagNames} tagConfidence={tagConfidence} maxTags={1} />
        </div>
      </div>
    </div>
  )
}

export default SnippetItem
